import { render, staticRenderFns } from "./TicketFormTable.vue?vue&type=template&id=73b280c2&"
import script from "./TicketFormTable.vue?vue&type=script&lang=js&"
export * from "./TicketFormTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports